<script lang="ts">
  import AutoComplete from '$shared/atoms/AutoComplete/AutoComplete.svelte';
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';
  import Label from '$provider/constants/Label';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';
  import { onMount } from 'svelte';

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: { type: string; data: any }) => void;
  }

  let { alert, onevent }: Props = $props();

  let boardCertType: string | undefined;
  let boardCertTypeLabel: string | undefined = $state();

  onMount(() => {
    boardCertType = alert?.props?.boardCertType;
    boardCertTypeLabel =
      alert.props?.list?.find((item: any) => item.id === boardCertType)?.label || '';
  });

  const onClickBoardType = (detail: CommonList): void => {
    boardCertType = detail.id;
    boardCertTypeLabel = detail.label;

    onevent?.({ type: 'change-boardtype', data: { key: alert.key, type: detail.id } });
  };

  const onBoardTypeInputCleared = (): void => {
    if (!boardCertType) return;
    boardCertType = '';
    boardCertTypeLabel = '';
    onevent?.({ type: 'clear-boardtype', data: { key: alert.key } });
  };
</script>

<AlertView
  type={ListAlertType.BoardCertTypeChange}
  key={Label.ChangeTo}
  icon="icon-corner-down-right"
>
  {#snippet value()}
    <div class="boardCertType">
      <AutoComplete
        name="boardCertType"
        list={alert.props?.list || []}
        placeholder="Search types"
        value={boardCertTypeLabel}
        onclick={onClickBoardType}
        oncleared={onBoardTypeInputCleared}
      />
    </div>
  {/snippet}
</AlertView>

<style>
  .boardCertType {
    width: 400px;
    padding: 4px 16px;
  }
</style>
